<template>
  <div>
    <h2>Dept Positions</h2>
    <a-spin :spinning="loading">
      <a-list itemLayout="horizontal" :dataSource="positions">
        <a-list-item slot="renderItem" slot-scope="item">
          <span>{{ item.name }}</span>
          <a slot="actions" @click="handleEdit(item)">Edit</a>
          <a-popconfirm
            slot="actions"
            title="Are you sure delete ?"
            @confirm="handleDelete(item)"
            okText="Yes"
            cancelText="No"
          >
            <a href="#">Delete</a>
          </a-popconfirm>
        </a-list-item>
        <div slot="footer">
          <a-button type="dashed" block @click="handleAdd">
            <a-icon type="plus"/>New Position
          </a-button>
        </div>
      </a-list>
    </a-spin>
    <DeptPositionEdit
      v-if="showEdit"
      :record="this.record"
      :departmentId="departmentId"
      @cancel="handleEditCancel"
      @confirm="handleEditConfirm"
    ></DeptPositionEdit>
  </div>
</template>

<script>
import DeptPositionEdit from './DeptPositionEdit'
import PositionApi from '@/api/adm/api-position'

export default {
  name: 'DeptPositionList',
  components: {
    DeptPositionEdit
  },
  props: {
    departmentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      positions: [],
      showEdit: false,
      record: null
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      const res = await this.loadPositions()
      const positions = res.data.datas
      if (positions && positions.length > 0) {
        this.positions = positions
      } else {
        this.positions = []
      }
      this.loading = false
    },
    loadPositions () {
      return PositionApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, { departmentId: this.departmentId }))
    },
    // 添加
    handleAdd () {
      this.record = ''
      this.showEdit = true
    },
    // 修改
    handleEdit (record) {
      this.record = record
      this.showEdit = true
    },
    handleEditCancel () {
      this.showEdit = false
    },
    handleEditConfirm () {
      this.showEdit = false
      this.initData()
    },
    handleDelete (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      PositionApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.initData()
        }
      })
    }
  }
}
</script>
